'use client';

import {styled} from "@mui/system";
import CardTitleBox from "@/src/mui-custom/card/card-title-box/card-title-box";

const ArchiveTitleBox = styled(CardTitleBox)(() => ({
    //
}));

export default ArchiveTitleBox;
